"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("@hig/button"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ActionButton = function ActionButton(_ref) {
  var className = _ref.className,
      title = _ref.title,
      type = _ref.type,
      handleClick = _ref.handleClick,
      _ref$enable = _ref.enable,
      enable = _ref$enable === void 0 ? true : _ref$enable,
      id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    disabled: !enable,
    title: title,
    type: type,
    className: className,
    onClick: handleClick,
    id: id
  });
};

ActionButton.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.any.isRequired,
  type: _propTypes.default.string,
  handleClick: _propTypes.default.func,
  enable: _propTypes.default.bool,
  id: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(ActionButton).withConfig({
  displayName: "ActionButton",
  componentId: "sc-177gws5-0"
})(["width:150px;height:45px;padding:5px;> span{font-weight:800;}:hover{background:#0582ba;}", ""], function (props) {
  return props.type === "outline" && (0, _styledComponents.css)(["border:1px solid #0696d7;color:#0696d7;font-weight:600;background:white;:hover{background:#0696d7;color:#f5f5f5;}"]);
});

exports.default = _default;